import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './SimpleNav.css';

const SimpleNav: React.FC = () => {
  return (
    <header className="simple-header">
      <div className="simple-header-content">
        <Link to="/" className="simple-logo">
          <Logo width="80px" height="80px" />
        </Link>
        
        <nav className="simple-nav">
          <Link to="/" className="simple-nav-link">Home</Link>
          <Link to="/about" className="simple-nav-link">About Us</Link>
          <Link to="/sponsors" className="simple-nav-link">Sponsors</Link>
          <Link to="/fixtures" className="simple-nav-link">Fixtures</Link>
          <Link to="/results" className="simple-nav-link">Results</Link>
          <Link to="/player-stats" className="simple-nav-link">Player Stats</Link>
          <Link to="/shop" className="simple-nav-link">Shop</Link>
        </nav>
      </div>
    </header>
  );
};

export default SimpleNav; 